import showSpinner from '@services/addSpinnerOnQueryStarted';
import addRealTimeListener from '@services/addRealTimeListener';
import appendPath from '@services/path';

const BASE_PATH = 'api/v1/admin/ruleSets';
const appendToApiPath = appendPath(BASE_PATH);

export const BRIEF_RULE_SETS_TAG = 'BiefRuleSets';
export const RULE_SETS_TAG = 'RuleSets';
export const CUSTOM_DATE_FORMAT_TAG = 'CustomDateFormat';
export const RULE_SETS_TAGS = [RULE_SETS_TAG, CUSTOM_DATE_FORMAT_TAG];

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').QueryDefinition<void, any, any, Dto.IRuleSet[]>}
 */
const getAll = (builder) =>
    builder.query({
        query: () => ({ url: BASE_PATH, method: 'GET' }),
        async onQueryStarted(id, api) { await showSpinner(api); },
        async onCacheEntryAdded(arg, api) { await addRealTimeListener('ruleSets', api); },
        providesTags: [RULE_SETS_TAG],
    });

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').QueryDefinition<void, any, any, Dto.IBriefRuleSet[]>}
 */
const getAllSummarized = (builder) =>
    builder.query({
        query: () => ({ url: appendToApiPath('summary'), method: 'GET' }),
        async onQueryStarted(_, api) { await showSpinner(api); },
        //async onCacheEntryAdded(arg, api) { await addRealTimeListener('briefRuleSets', api); },
        providesTags: [BRIEF_RULE_SETS_TAG],
    });

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').MutationDefinition<Dto.IRuleSet, any, any, Dto.IRuleSet>}
 */
const create = (builder) =>
    builder.mutation({
        query: (ruleSet) => ({ url: BASE_PATH, method: 'POST', data: ruleSet }),
        async onQueryStarted(id, api) { await showSpinner(api); },
        invalidatesTags: [RULE_SETS_TAG, BRIEF_RULE_SETS_TAG],
    });

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').MutationDefinition<Dto.IRuleSet, any, any, Dto.IRuleSet>}
 */
const update = (builder) =>
    builder.mutation({
        query: (ruleSet) => ({ url: appendToApiPath(ruleSet.id), method: 'PUT', data: ruleSet }),
        async onQueryStarted(id, api) { await showSpinner(api); },
        invalidatesTags: [RULE_SETS_TAG, BRIEF_RULE_SETS_TAG],
    });

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').MutationDefinition<Dto.IRuleSet, any, any, void>}
 */
const deleteRuleSet = (builder) =>
    builder.mutation({
        query: (ruleSet) => ({ url: `${appendToApiPath(ruleSet.id)}?ruleSetType=${ruleSet.ruleSetType}`, method: 'DELETE' }),
        async onQueryStarted(id, api) { await showSpinner(api); },
        invalidatesTags: [RULE_SETS_TAG, BRIEF_RULE_SETS_TAG],
    });

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query')
 *  .QueryDefinition<any, any, any, Dto.ICustomDateFormat[]>}
 */
const getCustomDateFormats = (builder) =>
    builder.query({
        query: () => ({ url: appendToApiPath('CustomDateFormat'), method: 'GET' }),
        async onQueryStarted(_, api) { await showSpinner(api); },
        providesTags: [CUSTOM_DATE_FORMAT_TAG],
    });

export const endpointsRuleSets = (builder) => ({
    getRuleSets: getAll(builder),
    getBriefRuleSets: getAllSummarized(builder),
    createRuleSet: create(builder),
    updateRuleSet: update(builder),
    deleteRuleSet: deleteRuleSet(builder),
    getCustomDateFormats: getCustomDateFormats(builder),
});
